import {UserMessage} from "../http/protocol";
import * as React from "react";
import {formatDate} from "../utils/date";
import {connect} from "react-redux";
import {markRead} from "../messages/MessageActions";
import {AppState} from "../RootReducer";
import {Dispatch} from "redux";
import {Link} from "react-router-dom";

interface MessageViewProps {
    message : UserMessage
    markRead : (id : number) => void;
}
export class MessageView extends React.Component<MessageViewProps>{
    constructor(props : MessageViewProps) {
        super(props);
    }
    componentDidMount() {
        window.scroll(0,0)
        if(this.props.message.id) {
            this.props.markRead(this.props.message.id)
        }
    }

    render() {
        return (
            <div className={"message-view"}>
                <div className={"row"}>
                    <div className={"col-md-1 back-container"}>
                        <Link to="/account/messages" className={"back"}>
                            <i className={"material-icons"}>arrow_back</i>
                        </Link>
                    </div>
                    <div className={"col-md-11"}>
                        <h5>{this.props.message.title} </h5>
                        <div className={"message-date"}>
                            {formatDate(this.props.message.created)}
                        </div>
                    </div>
                </div>


                {this.props.message.imageUrl && <div className={"message-image"}><img src={this.props.message.imageUrl}/></div>}

                <div className={"message-body"}>
                    {this.props.message.message}
                </div>

            </div>
        )
    }
}
const mapDispatchToProps = (dispatch : Dispatch) => {
    return {
        markRead: (id: number) => dispatch(markRead(id) as any)
    }
}
const mapStateToProps = (state : AppState)  => {
    return {}
}
export default connect(mapStateToProps, mapDispatchToProps)(MessageView);